import { render, staticRenderFns } from "./leaderApproval.vue?vue&type=template&id=4c12a86d&scoped=true"
import script from "./leaderApproval.vue?vue&type=script&lang=js"
export * from "./leaderApproval.vue?vue&type=script&lang=js"
import style0 from "./leaderApproval.vue?vue&type=style&index=0&id=4c12a86d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c12a86d",
  null
  
)

export default component.exports